<ng-template #otpChannelBody>
  <header class="dialog-header">
    <div class="header-icon-wrapper">
      <i class="fas fa-shield-alt" aria-hidden="true"></i>
    </div>
    <div class="header-text">
      <h3 id="otp-channel-title" tabindex="-1" cdkFocusInitial>Restablecer PIN – Verificación</h3>
      <p class="header-subtitle">Recibirá un código de verificación solo por correo electrónico asociado al certificado</p>
    </div>
    <p id="otp-channel-desc" class="sr-only">Envíe el código OTP al correo asociado al certificado</p>
  </header>

  <div class="otp-content">
    <div class="channel-card email-card" *ngIf="email">
      <div class="channel-icon-wrap">
        <i class="fas fa-envelope" aria-hidden="true"></i>
      </div>
      <div class="channel-body">
        <p class="label-channel">Correo asociado al certificado</p>
        <p class="masked-value email-value">{{ maskedEmail }}</p>
        <p class="help-text">
          Se enviará un código OTP a ese correo. Debe tener acceso a él para continuar.
        </p>
        <p class="send-otp-error" *ngIf="sendOtpError">{{ sendOtpError }}</p>
        <div class="actions">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeDialog()"
            [disabled]="sendingOtpEmail"
            aria-label="Cancelar">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-primary btn-send-otp"
            (click)="sendOtpEmail()"
            [disabled]="sendingOtpEmail"
            [attr.aria-label]="sendingOtpEmail ? 'Enviando código…' : 'Enviar OTP al correo ' + maskedEmail"
            [attr.aria-busy]="sendingOtpEmail">
            <i class="fas fa-spinner fa-spin" aria-hidden="true" *ngIf="sendingOtpEmail"></i>
            <i class="fas fa-paper-plane" aria-hidden="true" *ngIf="!sendingOtpEmail"></i>
            {{ sendingOtpEmail ? 'Enviando…' : 'Enviar OTP' }}
          </button>
        </div>
      </div>
    </div>

    <div class="channel-card no-email-card" *ngIf="!email">
      <div class="channel-icon-wrap warn">
        <i class="fas fa-info-circle" aria-hidden="true"></i>
      </div>
      <div class="channel-body">
        <p class="help-text warn">No se encontró correo electrónico en el certificado.</p>
        <p class="help-text">
          Para restablecer el PIN con verificación por correo, el certificado debe incluir un correo en el subject (campo E).
          Si necesita ayuda, contacte a soporte.
        </p>
        <div class="actions">
          <button type="button" class="btn btn-secondary" (click)="closeDialog()" aria-label="Cerrar">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="!embedded" mat-dialog-content role="dialog" aria-modal="true" aria-labelledby="otp-channel-title" aria-describedby="otp-channel-desc">
  <ng-container *ngTemplateOutlet="otpChannelBody"></ng-container>
</div>
<div *ngIf="embedded" class="tf-admin-step-panel tf-otp-channel-embedded" role="region" aria-labelledby="otp-channel-title" aria-describedby="otp-channel-desc">
  <ng-container *ngTemplateOutlet="otpChannelBody"></ng-container>
</div>
